import React from 'react'
import Main from '../components/CulturalPage/Main'

const CulturalPage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default CulturalPage